<script setup>
import { computed } from 'vue';
import { useItemListStore } from "../plugins/store/itemsList.store";
import { useHistoricStore } from "../plugins/store/historic.store";
import TreeViewSearchItemsList from "./treeViewSearchList.vue";

const { currentTaId } = defineProps({ currentTaId: Number });

const itemListStore = useItemListStore();
const historicStore = useHistoricStore();

const applicationHistoricByCurrentTa = computed(() => {
  if (currentTaId === 4)
    return historicStore.getSortedHistoricByApplication("vetanatomy").value;

  return historicStore.getSortedHistoricByApplication("eanatomy").value;
});

if (applicationHistoricByCurrentTa) { itemListStore.setItems(applicationHistoricByCurrentTa.value)}

const showHistoric = computed(() => applicationHistoricByCurrentTa.value.length > 0);
</script>

<template>
  <div v-if="showHistoric" class="search-historic">
    <div class="item-search-historic">
      <p @mousedown.prevent class="item-search-historic__title">
        {{ $t("search.tree-view.historic") }}
      </p>
      <div class="item-search-historic__Container">
        <TreeViewSearchItemsList :items="applicationHistoricByCurrentTa" :display-tag="true"/>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "/assets/css/theme/helpers/variables";
.search-historic {
  width: 100%;
}

.item-search-historic__title {
  color: variables.$body-color;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 0.25rem 1rem;
  margin: unset;
}
</style>
